export const environment = {
  production: false,
  serviceUrl: '/backend-config/',
  serviceUrlLogin: '/backend-login/',
  serviceUrl_Report: '/backend-report/',
  serviceUrl_Migra_Api: '/backend-migra-api/',
  serviceUrl_Prod: '/backend-prod-api/',
  serviceUrl_Notification: '/backend-notification/',
  serviceUrl_FE: '/backend-fe/',
  TSI_VERSIONES: "url_versiones",
  recaptcha: {
    siteKey: '6LdqZT0sAAAAAHAFBX8eo0fXQKCHYhd9C6IoY7UZ',
  }
}

